import React from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";
import i18n from "I18n";

import CustomTitleWithInput from "components/base/CustomTitleWithInput";
import { hasError, ReactHookFormErrorMessage } from "components/base/ErrorFieldMessage";

const ReactHookFormTextInput = ({
  focusChange = () => { },
  language,
  withTranslation = false,
  prefix="",
  translationFieldPrefix = "translations",
  valueFieldName,
  errorId,
  focusKey,
  title = "",
  unit,
  per,
  tips,
  shortDescription,
  type = 'text',
  customTitleClass,
  customClass,
  extraActionOnChange = () => { },
  disabled,
  blurAction,
  ...inputValues
}) => {
  const dispatch = useDispatch()
  const formContext = useFormContext()
  const {
    setValue,
    watch,
    formState: { errors }
  } = formContext;
  
  const realValueFieldName = withTranslation ? `${prefix || ""}${translationFieldPrefix}.${language}.${valueFieldName}` : `${prefix}${valueFieldName}`;
  const displayTitle = title && withTranslation ? i18n.t(title, { locale: language }) : title;
  const displayTips = tips && withTranslation ? i18n.t(tips, { locale: language }) : tips;
  const displayShortDescription = shortDescription && withTranslation ? i18n.t(shortDescription, { locale: language }) : shortDescription;
  const watchValue = watch(realValueFieldName) || "";

  const onValueChange = (value) => {
    setValue(realValueFieldName, value, { shouldDirty: true })
    extraActionOnChange && extraActionOnChange({
      language,
      dispatch,
      formContext,
      value,
    })
  }

  const onFocusChange = () => {
    focusKey && focusChange(focusKey)
  }

  return (
    <>
      <CustomTitleWithInput
        title={displayTitle}
        type={type}
        error={{ error: hasError(errors, realValueFieldName) }}
        setValue={onValueChange}
        focusChange={onFocusChange}
        defaultValue={watchValue}
        useDefaultValue={false}
        extra={{ ...inputValues, value: watchValue, onChange: ({ target }) => onValueChange(target.value) }}
        customTitleClass={customTitleClass}
        customClass={`${customClass || ""} ${hasError(errors, realValueFieldName) ? 'error-field' : ''}`}
        disabled={disabled}
        blurAction={blurAction}
        unit={unit}
        per={per}
        shortDescription={displayShortDescription}
        tips={displayTips}
      />
      <ReactHookFormErrorMessage errors={errors} id={errorId || realValueFieldName} />
    </>
  )
}

export default ReactHookFormTextInput;